// Load scores from local storage or initialize to 0
export const loadScoresFromLocal = () => {
    try {
        const scores = localStorage.getItem('scores');
        return scores ? parseInt(scores) : 0;
    } catch (error) {
        console.error('Error loading scores from local storage:', error);
        return 0;
    }
};

// Save scores to local storage
export const saveScoresToLocal = (scores) => {
    try {
        localStorage.setItem('scores', scores.toString());
    } catch (error) {
        console.error('Error saving scores to local storage:', error);
    }
};